import React, { useEffect, useState } from 'react';
import { Card, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { Pencil, Person, Envelope, Telephone } from 'react-bootstrap-icons';

const BuyerProfile = () => {
  const userId = 14; // Replace with dynamic user ID
  const [profile, setProfile] = useState({});
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', mobile: '' });

  useEffect(() => {
    axios.get(`https://vyaparapi.emedha.in/api/auth/api/users/${userId}`).then((res) => {
      setProfile(res.data);
      setFormData(res.data);
    });
  }, [userId]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`https://vyaparapi.emedha.in/api/auth/api/users/${userId}`, formData);
      setProfile(formData);
      setEditing(false);
      alert('✅ Profile updated successfully!');
    } catch (err) {
      alert('❌ Update failed!');
    }
  };

  return (
    <Card
      style={{
        maxWidth: '600px',
        margin: '40px auto',
        borderRadius: '16px',
        boxShadow: '0 8px 20px rgba(6, 45, 89, 0.15)',
        background: '#fff',
        border: `2px solid #062d59`,
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <Card.Body style={{ padding: '32px 36px' }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4
            style={{
              color: '#062d59',
              fontWeight: '700',
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
            }}
          >
            👤 Buyer Profile
          </h4>
          <Button
            variant="outline-primary"
            style={{
              borderColor: '#062d59',
              color: '#062d59',
              fontWeight: '600',
              letterSpacing: '0.03em',
              transition: 'all 0.3s ease',
            }}
            onClick={() => setEditing(!editing)}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#062d59';
              e.currentTarget.style.color = '#fff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#062d59';
            }}
          >
            <Pencil className="me-1" /> {editing ? 'Cancel' : 'Edit'}
          </Button>
        </div>

        {editing ? (
          <Form
            style={{
              backgroundColor: '#f9fafd',
              padding: '24px',
              borderRadius: '12px',
              boxShadow: 'inset 0 0 10px rgba(6, 45, 89, 0.1)',
            }}
          >
            <Form.Group className="mb-4">
              <Form.Label
                style={{
                  color: '#062d59',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '1rem',
                }}
              >
                <Person /> Name
              </Form.Label>
              <Form.Control
                name="name"
                value={formData.name}
                onChange={handleChange}
                style={{
                  borderColor: '#062d59',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  padding: '10px 14px',
                  transition: 'border-color 0.3s ease',
                }}
                onFocus={(e) => (e.target.style.borderColor = '#e3080c')}
                onBlur={(e) => (e.target.style.borderColor = '#062d59')}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label
                style={{
                  color: '#062d59',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '1rem',
                }}
              >
                <Envelope /> Email
              </Form.Label>
              <Form.Control
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={{
                  borderColor: '#062d59',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  padding: '10px 14px',
                  transition: 'border-color 0.3s ease',
                }}
                onFocus={(e) => (e.target.style.borderColor = '#e3080c')}
                onBlur={(e) => (e.target.style.borderColor = '#062d59')}
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label
                style={{
                  color: '#062d59',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '1rem',
                }}
              >
                <Telephone /> Mobile
              </Form.Label>
              <Form.Control
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                style={{
                  borderColor: '#062d59',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  padding: '10px 14px',
                  transition: 'border-color 0.3s ease',
                }}
                onFocus={(e) => (e.target.style.borderColor = '#e3080c')}
                onBlur={(e) => (e.target.style.borderColor = '#062d59')}
              />
            </Form.Group>

            <div className="d-flex gap-3">
              <Button
                style={{
                  backgroundColor: '#e3080c',
                  border: 'none',
                  fontWeight: '700',
                  padding: '10px 28px',
                  borderRadius: '10px',
                  boxShadow: '0 4px 10px rgba(227, 8, 12, 0.4)',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#b20609')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#e3080c')}
                onClick={handleUpdate}
              >
                Update
              </Button>
              <Button
                variant="outline-secondary"
                style={{
                  borderRadius: '10px',
                  fontWeight: '600',
                  padding: '10px 28px',
                }}
                onClick={() => setEditing(false)}
              >
                Cancel
              </Button>
            </div>
          </Form>
        ) : (
          <div
            style={{
              fontSize: '17px',
              color: '#062d59',
              lineHeight: '2.2',
              fontWeight: '500',
              letterSpacing: '0.02em',
              userSelect: 'none',
            }}
          >
            <p>
              <Person className="me-2" size={20} /> <strong>Name:</strong> {profile.name || 'N/A'}
            </p>
            <p>
              <Envelope className="me-2" size={20} /> <strong>Email:</strong> {profile.email || 'N/A'}
            </p>
            <p>
              <Telephone className="me-2" size={20} /> <strong>Mobile:</strong> {profile.mobile || 'N/A'}
            </p>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default BuyerProfile;
